import { render, staticRenderFns } from "./IconPickerDialog.vue?vue&type=template&id=106b4846&scoped=true&"
import script from "./IconPickerDialog.vue?vue&type=script&lang=js&"
export * from "./IconPickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconPickerDialog.vue?vue&type=style&index=0&id=106b4846&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b4846",
  null
  
)

export default component.exports